module.exports = __webpack_public_path__ + "img/about-3.aa762547.jpg";